export const ERROR_CODES = [
  'VALIDATION_ERROR',
  'NOT_FOUND',
  'CONFLICT',
  'CONFIGURATION_ERROR',
  'UNSUPPORTED',
  'UNAVAILABLE',
  /** Operacion cancelada por el llamador (AbortSignal). */
  'CANCELLED',
  /** Un servicio externo no respondio dentro del tiempo maximo. */
  'TIMEOUT',
  /** Un servicio externo respondio con un error o con una respuesta no valida. */
  'UPSTREAM_ERROR',
  /** La peticion o la respuesta supera el tamano maximo permitido. */
  'PAYLOAD_TOO_LARGE',
  /** Falta una sesion valida para una operacion protegida. */
  'UNAUTHORIZED',
  /** La peticion no cumple las protecciones exigidas (CSRF, origen) o no esta permitida. */
  'FORBIDDEN',
  /** Demasiados intentos en poco tiempo. */
  'RATE_LIMITED',
  'INTERNAL_ERROR',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

/** Detalle puntual de un error, normalmente asociado a una ruta dentro de un documento. */
export interface ErrorDetail {
  /** Ruta en notacion de puntos, por ejemplo `tables.0.columns.2.name`. */
  readonly path: string;
  readonly message: string;
}

export interface AppErrorOptions {
  readonly details?: readonly ErrorDetail[];
  readonly cause?: unknown;
}

/** Error de dominio con codigo estable, apto para serializarse entre modulos y por HTTP. */
export class AppError extends Error {
  override readonly name = 'AppError';
  readonly code: ErrorCode;
  readonly details: readonly ErrorDetail[];

  constructor(code: ErrorCode, message: string, options: AppErrorOptions = {}) {
    super(message, options.cause === undefined ? undefined : { cause: options.cause });
    this.code = code;
    this.details = options.details ?? [];
  }

  toJSON(): { code: ErrorCode; message: string; details: readonly ErrorDetail[] } {
    return { code: this.code, message: this.message, details: this.details };
  }
}

export const isAppError = (value: unknown): value is AppError => value instanceof AppError;
